<a
  target="_blank"
  [attr.href]="editPath"
  data-dgat="orgPages-5a8"
  class="uhover color-ebony"
  (click)="trackPlanViewed()"
>
  <span [id]="`table-row-label-${plan.id}`">
    {{ plan.name }}
  </span>
</a>
@if (plan.hideSelect && i18n.OrgPlans_OnFeaturedTooltip) {
  <button
    type="button"
    [ngbTooltip]="i18n.OrgPlans_OnFeaturedTooltip"
    class="tw-btn-icon tw-btn-tertiary-neutral -tw-my-1 tw-align-middle"
    data-dgat="orgPages-7b3"
  >
    <da-icon
      icon="exclamation-circle"
      type="solid-small"
      [ariaLabel]="i18n.OrgPlans_OnFeaturedTooltip"
      class="tw-reset tw-inline-block tw-align-middle"
    />
  </button>
}
